module.exports = __webpack_public_path__ + "img/vitorinofreire_footer.431b674b.png";